import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  USER_FORM_FIELD_NAME_FIRST_NAME,
  USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH,
} from '../../../../User'

import { getFirstNameFieldNextValue } from './FirstNameField.utils'

import * as styles from '../InhabitantFormFields.module.css'

function FirstNameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.FirstNameLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getFirstNameFieldNextValue}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH}
      name={USER_FORM_FIELD_NAME_FIRST_NAME}
      placeholder={t('Inhabitant.FirstNamePlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default FirstNameField
